/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import LogModel from 'cio/models/log';
import AnalyticsService from 'cio/services/analytics';
import { tracked } from '@glimmer/tracking';
import { RESTRICTED_ATTRIBUTES, RESTRICTED_EVENT_ATTRIBUTES } from 'cio/utils/attributes';
import { ActivityLogType } from 'cio/utils/activity-log-types';

interface ActivityLogRowArgs {
  log: LogModel;
  columns: number;
  expanded?: boolean;
  onSendTestWithLog?: () => unknown;
}

export default class ActivityLogRow extends Component<ActivityLogRowArgs> {
  @service analytics!: AnalyticsService;

  @tracked expanded = false;

  get logTypesContainingIdentifiers() {
    return [
      ActivityLogType.AttributeChange,
      ActivityLogType.ProfileCreate,
      ActivityLogType.ProfileDelete,
      ActivityLogType.ProfileMerge,
    ];
  }

  get logTypesContainingNestedIdentifiers() {
    return [ActivityLogType.ProfileMerge];
  }

  get renderHtml() {
    return this.args.log.type === ActivityLogType.FailedObjectJourneys;
  }

  get reservedAttributes() {
    if (this.args.log.type === ActivityLogType.Event) {
      return RESTRICTED_EVENT_ATTRIBUTES;
    } else if (this.args.log.type === ActivityLogType.AttributeChange) {
      return RESTRICTED_ATTRIBUTES;
    }

    return [];
  }

  constructor(owner: unknown, args: ActivityLogRowArgs) {
    super(owner, args);

    this.expanded = args.expanded ?? false;
  }

  @action
  toggleExpanded() {
    this.analytics.track('logs', 'specific_activity_viewed', {
      isAnonymousMergeEvent: this.args.log.isAnonymousMergeEvent,
      isPeopleMergeEvent: this.args.log.isPeopleMergeEvent,
    });

    this.expanded = !this.expanded;
  }
}
